import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReportingViewsService } from './services/reporting-views/reporting-views.service';
import { REPORTING_VIEWS_SERVICE_TOKEN } from './services/reporting-views/reporting-views.token';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSliderModule } from '@angular/material/slider';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBadgeModule } from '@angular/material/badge'; 
import { RichTextEditorModule, ToolbarService as RteToolbarService, LinkService as RteLinkService, ImageService as RteImageService, HtmlEditorService as RteHtmlEditorService, QuickToolbarService as RteQuickToolbarService } from '@syncfusion/ej2-angular-richtexteditor';
import { ScheduleModule } from '@syncfusion/ej2-angular-schedule';
import {
  ColumnChooserService,
  EditService,
  FilterService,
  GridAllModule,
  PageService,
  SortService,
  ToolbarService,
} from '@syncfusion/ej2-angular-grids';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonSyncfusionTableComponent } from './components/common-syncfusion-table/common-syncfusion-table.component';
import { InternalBadgeComponent } from './components/internal-badge/internal-badge.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DrawingPadComponent } from './components/drawing-pad/drawing-pad.component';
import { SyncfusionHierarchyTableComponent } from './components/syncfusion-hierarchy-table/syncfusion-hierarchy-table.component';
import { QRCodeComponent } from 'angularx-qrcode';
//import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { LightboxModule } from 'ng-gallery/lightbox';
import { GalleryModule } from 'ng-gallery';
import { ReassignWoPopupComponent } from './components/reassign-wo-popup/reassign-wo-popup.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CreateChildWOPopupComponent } from './components/create-child-wo-popup/create-child-wo-popup.component';
import { DashboardLayoutModule } from '@syncfusion/ej2-angular-layouts';
import { DateRangePickerModule, DateTimePickerModule, MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars'
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CheckBoxSelectionService, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ImportBuildWoComponent } from './components/import-build-wo/import-build-wo.component';
import { ImportWomsDefectComponent } from './components/import-woms-defect/import-woms-defect.component';
import { NoSpecialCharacterDirective } from './directives/no-special-character/no-special-character.directive';
import { SorCommentsDialogComponent } from '../features/work-orders/work-order-details/components/sor-comments-dialog/sor-comments-dialog.component';
import { DownloadWoPopupComponent } from './components/download-wo-popup/download-wo-popup.component';
import { CheckListPdfDialogComponent } from './components/check-list-pdf-dialog/check-list-pdf-dialog.component';
import { ExportWoDialogComponent } from './components/export-wo-dialog/export-wo-dialog.component';
import { ClickOutsideDirective } from './directives/no-special-character/click-outside.directive'
import { HelpIconComponent } from './components/help-icon/help-icon.component';
import { HelpPageComponent } from './components/help-page/help-page.component';
import { LinkModuleComponent } from './components/link-module/link-module.component';
import { NotificationCenterComponent } from './components/notification-center/notification-center.component';
import { NotificationTileListComponent } from './components/notification-center/notification-tile-list.component';
import { MatSelectionList, MatListOption } from "@angular/material/list";
import { LinkModuleSectionsComponent } from './components/link-module-sections/link-module-sections.component';
import { SystemFormComponent } from './components/system-form/system-form.component';
import { SystemFormWrapperComponent } from './components/system-form/system-form-wrapper/system-form-wrapper.component';
import { PreviewTemplateComponent } from '../features/template/component/preview-template/preview-template.component';
import { TemplateMediaComponent } from '../features/template/component/template-media/template-media.component';
import { MatDivider } from '@angular/material/divider';
import { RightDrawerComponent } from './components/right-drawer/right-drawer.component';
import { CommentSectionComponent } from './components/comment-section/comment-section.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { CreateActionComponent } from './components/create-action/create-action.component';
import { GlobalLinkModuleComponent } from './components/global-link-module/global-link-module.component';
import { MatDrawer, MatDrawerContainer, MatDrawerContent } from "@angular/material/sidenav";
import { JobCodeDialogComponent } from './components/job-code-dialog/job-code-dialog.component';
import { LookupSelectDialogComponent } from './components/lookup-select-dialog/lookup-select-dialog.component';
import { GooglePlacesAutocompleteDirective } from './directives/google-place-autocomplete/google-place-autocomplete.directive';
import { CountUpDirective } from './directives/count-up/count-up.directive';
import { WebCopyDirective } from './directives/web-copy/web-copy.directive';
import { ActivityTimelineComponent } from './components/activity-timeline/activity-timeline.component';
import { ExportDataDialogComponent } from './components/export-data-dialog/export-data-dialog.component';
import { ExportModalComponent } from './components/export-modal/export-modal.component';
import { ColumnChooserButtonComponent } from './components/column-chooser-button/column-chooser-button.component';
import { SavedViewsComponent } from './components/saved-views/saved-views.component';
import { CreateViewDialogComponent } from './components/saved-views/create-view-dialog/create-view-dialog.component';
import { ViewsListDialogComponent } from './components/saved-views/views-list-dialog/views-list-dialog.component';
import { ArcadeLinkPanelComponent } from './components/arcade-link-panel/arcade-link-panel.component';
import { ArcadeGuideViewerComponent } from './components/arcade-guide-viewer/arcade-guide-viewer.component';
import { TagsComponent } from './components/tags/tags.component';
import { PermissionsModule } from '../core/permissions/permissions.module';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { TaskListModalComponent } from './components/tasks/task-list-modal/task-list-modal.component';
import { StatusLabelComponent } from './components/status-label/status-label.component';
import { BrandIconPipe } from '../core/icons/brand-icon.pipe';
import { RecordStateFamilyPipe, StatusFamilyPipe } from './utils/status-family.pipe';
const materialModules = [
  MatButtonModule,
  MatInputModule,
  MatSelectModule,
  MatDatepickerModule,
  MatCheckboxModule,
  MatIconModule,
  MatMenuModule,
  MatTabsModule,
  MatExpansionModule,
  MatStepperModule,
  MatCardModule,
  MatTooltipModule,
  MatRadioModule,
  MatDialogModule,
  MatSliderModule,
  MatTimepickerModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatButtonToggleModule,
  MatSlideToggleModule,
  MatBadgeModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatFormFieldModule,
  MatChipsModule,
  MatAutocompleteModule,
  NgxMatSelectSearchModule,
  MatSelectionList,
  MatListOption,
  MatDivider,
  MatDrawer,
  MatDrawerContainer,
  MatDrawerContent
];
const sharedComponents = [NotificationCenterComponent, NotificationTileListComponent,
  ArcadeLinkPanelComponent, ArcadeGuideViewerComponent];
@NgModule({
  declarations: [
    ...sharedComponents,
    CommonSyncfusionTableComponent,
    ConfirmDialogComponent,
    SyncfusionHierarchyTableComponent,
    ReassignWoPopupComponent,
    CreateChildWOPopupComponent,
    DrawingPadComponent,
    ImportBuildWoComponent,
    ImportWomsDefectComponent,
    SorCommentsDialogComponent,
    NoSpecialCharacterDirective,
    DownloadWoPopupComponent,
    CheckListPdfDialogComponent,
    ExportWoDialogComponent,
    ClickOutsideDirective,
    LinkModuleComponent,
    LinkModuleSectionsComponent,
    HelpIconComponent,
    HelpPageComponent,
    SystemFormComponent,
    SystemFormWrapperComponent,
    PreviewTemplateComponent,
    TemplateMediaComponent,
    RightDrawerComponent,
    CommentSectionComponent,
    CreateActionComponent,
    TagsComponent,
    SafeHtmlPipe,
    GooglePlacesAutocompleteDirective,
    CountUpDirective,
    GlobalLinkModuleComponent,
    JobCodeDialogComponent,
    LookupSelectDialogComponent,
    ActivityTimelineComponent,
    ExportDataDialogComponent,
    ExportModalComponent,
    SavedViewsComponent,
    CreateViewDialogComponent,
    ViewsListDialogComponent,
    AddressFormComponent,
    TaskListModalComponent,
  ],
  imports: [
    CommonModule,
    InternalBadgeComponent,
    StatusLabelComponent,
    BrandIconPipe,
    RecordStateFamilyPipe, StatusFamilyPipe,
    PermissionsModule,
    WebCopyDirective,
    materialModules,
    FormsModule,
    ReactiveFormsModule,
    GridAllModule,
    DialogModule,
    RichTextEditorModule,
    QRCodeComponent,
    LightboxModule,
    GalleryModule,
    ScheduleModule,
    DashboardLayoutModule,
    DateRangePickerModule,
    DateTimePickerModule,
    MultiSelectModule,
    RouterModule,
    DragDropModule,
    ScrollingModule,
    MatSelectionList,
    MatListOption,
    MatDivider,
    // Standalone; imported so SavedViewsComponent's filter row can render the Edit Columns button
    // for hosts that pass column config to it.
    ColumnChooserButtonComponent,
],
  providers: [
    provideNativeDateAdapter(),
    ToolbarService,
    ColumnChooserService,
    SortService,
    PageService,
    FilterService,
    EditService,
    CheckBoxSelectionService,
    DatePipe,
    // Syncfusion Rich Text Editor services
    RteToolbarService,
    RteLinkService,
    RteImageService,
    RteHtmlEditorService,
    RteQuickToolbarService,
    MaskedDateTimeService,
    // Default: SavedViewsComponent uses the list-page ReportingViewsService.
    // DashboardModule overrides this with DashboardReportingViewsService.
    { provide: REPORTING_VIEWS_SERVICE_TOKEN, useExisting: ReportingViewsService },
    // {
    //   provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
    //   subscriptSizing: 'dynamic',
    //   appearance: 'outline'
    // }}
  ],
  exports: [
    StatusLabelComponent,
    BrandIconPipe,
    RecordStateFamilyPipe, StatusFamilyPipe,
    ...sharedComponents,
    InternalBadgeComponent,
    PermissionsModule,
    materialModules,
    ReactiveFormsModule,
    FormsModule,
    GridAllModule,
    DialogModule,
    CommonSyncfusionTableComponent,
    SyncfusionHierarchyTableComponent,
    RichTextEditorModule,
    QRCodeComponent,
    LightboxModule,
    GalleryModule,
    ScheduleModule,
    ReassignWoPopupComponent,
    CreateChildWOPopupComponent,
    DashboardLayoutModule,
    DateRangePickerModule,
    DateTimePickerModule,
    MultiSelectModule,
    RouterModule,
    DragDropModule,
    ScrollingModule,
    ImportBuildWoComponent,
    ImportWomsDefectComponent,
    NoSpecialCharacterDirective,
    DownloadWoPopupComponent,
    CheckListPdfDialogComponent,
    ExportWoDialogComponent,
    ClickOutsideDirective,
    LinkModuleComponent,
    LinkModuleSectionsComponent,
    HelpIconComponent,
    HelpPageComponent,
    SystemFormComponent,
    SystemFormWrapperComponent,
    PreviewTemplateComponent,
    RightDrawerComponent,
    CommentSectionComponent,
    SafeHtmlPipe,
    GooglePlacesAutocompleteDirective,
    CountUpDirective,
    WebCopyDirective,
    GlobalLinkModuleComponent,
    ActivityTimelineComponent,
    ExportDataDialogComponent,
    SavedViewsComponent,
    TagsComponent,
    CreateViewDialogComponent,
    ViewsListDialogComponent,
    AddressFormComponent,
    TaskListModalComponent,
    ],
})
export class SharedModule {}
